

export const DEFAULT_CONFIG = {
    prevent_network_race: false,
    retry_request: false,
    custom_error_handler: false,
    authenticate: false,
};

export const SERVER_IP = process.env.REACT_APP_ML_SERVER_ENDPOINT;